import { Award } from "lucide-react";

/** "C of the Week · Coachability" (this week) and "3× C of the Week" (career) chips. */
export const CWeekBadge = ({ cw, testid, compact = false }) => (cw ? (
  <div data-testid={testid} className="flex flex-wrap gap-1.5">
    {cw.current && (
      <span data-testid={`${testid}-current`} className={`inline-flex items-center gap-1 rounded-full bg-[#39FF14] font-mono-gd font-bold uppercase tracking-wider text-[#0A0E1A] ${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"}`}>
        <Award className="h-3 w-3" />C of the Week · {cw.current}
      </span>
    )}
    <span data-testid={`${testid}-count`} className={`inline-flex items-center gap-1 rounded-full border border-[#39FF14]/50 bg-[#0A0E1A]/85 font-mono-gd font-bold uppercase tracking-wider text-[#39FF14] ${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"}`}>
      {cw.count}× C of the Week
    </span>
  </div>
) : null);
